import {useState, useEffect} from "preact/compat";
import {useBehavioralContext, useUserContext} from "../../../contexts";
import { useAppContext } from "../../../contexts";

export const useHeader = () => {
    // State to control the box shadow at the second header when the user scrolls down the page
    const [hasScrolled, setHasScrolled] = useState(false);

    const [vendor, setVendor] = useState("DEFAULT");

    // Retrieves the menu action stuff
    const {handleMenu} = useBehavioralContext();

    const {handTalkData, setFullPageLoader} = useAppContext();

    const [{}, {}, {}, {affiliationData}] = useUserContext();

    // Function to handle the scroll event listener
    function handleScroll() {
        this.scrollY <= 25 ? setHasScrolled(false) : setHasScrolled(true);
    }

    const handleHandTalk = () => {
        try{
            setFullPageLoader(true);
            
            if(!handTalkData.enable) {
                throw new Error('handtalk está desabilitado ou não foi carregado corretamente');
            }
            
            const handTalkContainer = document.getElementsByClassName('ht-skip');

            if(handTalkContainer.length > 0) {
                if(handTalkContainer[0].classList.contains('hidden')) {
                    handTalkContainer[0].classList.remove('hidden');
                } else {
                    handTalkContainer[0].classList.add('hidden');
                }
                return;
            }

            new HT({
                token: handTalkData.token,
                maxTexSize: 1000
            });
    
            console.log('handtalk ativado');
        } catch(error) {
            console.log('erro ao ativar handtalk: ', error.message, error);
        }finally {
            setFullPageLoader(false);
        }
    }

    useEffect(() => {
        if(!!affiliationData?.vendor) {
            setVendor(affiliationData?.vendor);
        }
    }, [affiliationData]);

    useEffect(() => {
        // An event listener to observe the scroll position of the window
        // in order to add the box shadow css property to the second header
        window.addEventListener("scroll", handleScroll);

        // Clears the event listener when component is dismounted
        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    return {
        hasScrolled,
        handleMenu,
        handleHandTalk,
        vendor
    }
}
